/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../../nls/StringResources',
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit'
], function (_, stringResources, React, PropTypes, Toolkit) {

	const {
		Checkbox
	} = Toolkit;

	class RankSection extends React.Component {
		static propTypes = {
			value: PropTypes.bool.isRequired,
			enabled: PropTypes.bool.isRequired,
			onValueChange: PropTypes.func.isRequired
		}

		render() {
			return (
				<Checkbox
					className="rank"
					label={stringResources.get('topbottomRankColumnLabel')}
					checked={!!this.props.value}
					onChange={value => this.props.onValueChange(value)}
					disabled={!this.props.enabled}
				/>
			);
		}
	}

	return RankSection;
});
